/* The editorial homepage uses native images and KLIK controls. Load Motion only
 * if a native theme section/control is actually present (including future edits).
 * Product, collection and cart pages retain their existing synchronous order. */
(() => {
  'use strict';
  const config = document.currentScript;
  if (!config) return;
  const nativeContent = '[data-section-type],.quick-product__btn,.js-drawer-open-cart,[data-add-to-cart],.lazyload,[data-aos]';
  if (!document.querySelector(nativeContent)) return;
  const load = (src, attributes = {}) => new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    Object.assign(script, attributes);
    script.onload = resolve;
    script.onerror = reject;
    document.head.append(script);
  });
  const styles = [config.dataset.themeStyle, config.dataset.baseStyle, config.dataset.storeStyle].filter(Boolean).map(href => new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet'; link.href = href;
    link.onload = resolve; link.onerror = reject;
    document.head.append(link);
  }));
  // The self-hosted copy from layout/theme.liquid (PF-10); it is normally already loaded (deferred).
  const jquery = window.jQuery ? Promise.resolve() : load(config.dataset.jquery);
  Promise.all([...styles, jquery.then(() => load(config.dataset.vendor))]).then(() => load(config.dataset.runtime)).then(async () => {
    for (const source of [config.dataset.cartDisplay, config.dataset.dpoProperties, config.dataset.dpoPopup, config.dataset.modelUi]) {
      if (source) await load(source);
    }
    if (!window.klikTransformationCart && window.theme?.CartDrawer && document.getElementById('CartDrawerForm')) {
      window.klikTransformationCart = new window.theme.CartDrawer();
    }
    document.dispatchEvent(new CustomEvent('klik:legacy-ready'));
  }).catch(() => {
    // Product and cart links remain normal navigation if an optional asset fails.
    console.warn('The optional theme section could not load.');
  });
})();
